import { Button } from "@base/ui/Button/Button";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_authenticated/apply/success")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center min-h-[calc(100vh-80px)] p-6">
      <div className="p-4 max-w-[468px] mx-auto bg-gray-10 flex flex-col gap-4 rounded-16">
        <p className="text-body1 font-semibold">{t("apply.payment.welcomeTo82Office")}</p>
        <p className="text-body1 whitespace-pre-wrap mb-2">{t("apply.payment.welcomeDescription")}</p>
        <Button
          variant="fill"
          color="primary"
          onClick={() => {
            navigate({ to: "/" });
          }}
        >
          {t("apply.payment.returnToMain")}
        </Button>
      </div>
    </div>
  );
}
